import script from "./CallButtonStickyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CallButtonStickyPanel.vue?vue&type=script&setup=true&lang=js"

import "./CallButtonStickyPanel.vue?vue&type=style&index=0&id=520fe1da&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520fe1da"]])

export default __exports__